import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./circuit.png"

const 高電流_高電圧_多電源 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { circuit: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"高電流（10A以上）\n高電圧（50V以上）\n多電源（4種以上）"}
      src={img}
      helpURL={HELP_LINKS["高電流（10A以上）高電圧（50V以上）多電源（4種以上）"]}
    >
      <RadioGroup name={estimateField.circuit.key} selectedValue={values.circuit} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["高電流（10A以上）高電圧（50V以上）多電源（4種以上）"].あり.value}>
            あり
          </Radio>
          <Radio value={ESTIMATE_CONSTANT["高電流（10A以上）高電圧（50V以上）多電源（4種以上）"].なし.value}>
            なし
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.circuit} />
    </OneClickField>
  )
}

export default 高電流_高電圧_多電源
